import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const RecommendationCard = ({ recommendation, onSave, onViewDetails }) => {
  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden hover:shadow-lg transition-all duration-250 group">
      <div className="relative h-48 md:h-56 overflow-hidden">
        <Image
          src={recommendation?.image}
          alt={recommendation?.imageAlt}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3 flex gap-2">
          <span className="px-3 py-1 bg-primary text-primary-foreground text-xs font-semibold rounded-full flex items-center gap-1">
            <Icon name="Sparkles" size={12} />
            Recommended
          </span>
          {recommendation?.discount && (
            <span className="px-3 py-1 bg-success text-success-foreground text-xs font-semibold rounded-full">
              {recommendation?.discount}% OFF
            </span>
          )}
        </div>
        <button
          onClick={() => onSave(recommendation?.id)}
          className="absolute top-3 right-3 w-10 h-10 bg-background/90 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-all duration-250"
          aria-label="Save to favorites"
        >
          <Icon name="Heart" size={20} />
        </button>
      </div>
      <div className="p-4 md:p-5">
        <div className="mb-3">
          <h3 className="text-lg md:text-xl font-bold text-foreground mb-1 line-clamp-1">
            {recommendation?.name}
          </h3>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="MapPin" size={14} />
            <span className="line-clamp-1">{recommendation?.location}</span>
          </div>
        </div>

        <p className="text-sm text-muted-foreground mb-3 line-clamp-2">
          {recommendation?.description}
        </p>

        <div className="flex items-center gap-3 mb-4 pb-4 border-b border-border">
          <div className="flex items-center gap-1">
            <Icon name="Star" size={16} fill="var(--color-accent)" color="var(--color-accent)" />
            <span className="text-sm font-semibold text-foreground">{recommendation?.rating}</span>
          </div>
          <span className="text-muted-foreground">•</span>
          <div className="flex items-center gap-1 text-sm text-muted-foreground">
            <Icon name="Users" size={14} />
            <span>{recommendation?.popularity}</span>
          </div>
          <span className="text-muted-foreground">•</span>
          <div className="flex items-center gap-1 text-sm text-muted-foreground">
            <Icon name="TrendingUp" size={14} />
            <span>{recommendation?.matchScore}% match</span>
          </div>
        </div>

        <div className="flex items-center justify-between mb-4">
          <div>
            <p className="text-xs text-muted-foreground">Starting from</p>
            <div className="flex items-baseline gap-2">
              {recommendation?.originalPrice && (
                <span className="text-sm text-muted-foreground line-through">
                  ₱{recommendation?.originalPrice?.toLocaleString('en-PH')}
                </span>
              )}
              <span className="text-xl font-bold text-primary whitespace-nowrap">
                ₱{recommendation?.price?.toLocaleString('en-PH')}
              </span>
            </div>
          </div>
          <div className="text-right">
            <p className="text-xs text-muted-foreground">Why recommended?</p>
            <p className="text-xs font-semibold text-foreground">{recommendation?.reason}</p>
          </div>
        </div>

        <Button
          variant="default"
          size="sm"
          fullWidth
          onClick={() => onViewDetails(recommendation?.id)}
          iconName="ArrowRight"
          iconPosition="right"
        >
          Explore Now
        </Button>
      </div>
    </div>
  );
};

export default RecommendationCard;